















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ItemSectionOption } from "@/models/itemSectionOption";
import Checkbox from "@/components/Checkbox.vue";

@Component({
  components: {
    Checkbox
  }
})
export default class extends Vue {
  @Prop({ type: Object, required: true }) option!: ItemSectionOption;

  private click() {
    this.$emit("optionSelected", this.option);
  }
}
